import React, { Component } from 'react';

import styles from './LoadMore.scss';
import ArrowIcon from './button-arrow.svg';

class LoadMore extends Component {
  render() {
    const isLoadingClass = this.props.isLoading ? ' is-loading' : '';
    return (
      <button
        className={`LoadMore${  isLoadingClass}`}
        onClick={this.props.onClick}
      >
        <ArrowIcon className="LoadMore__arrow" />
        <label className="LoadMore__label">
          {this.props.isLoading ? 'Loading' : 'Load More'}
        </label>
        <ArrowIcon className="LoadMore__arrow" />
      </button>
    );
  }
}

export default LoadMore;
